/* Address */
// mutations
export const ADDRESS__MUTATE_ADDRESS = 'ADDRESS__MUTATE_ADDRESS';
export const ADDRESS__MUTATE_MANUAL_STREET_NUMBER = 'ADDRESS__MUTATE_MANUAL_STREET_NUMBER';
export const ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER =
    'ADDRESS__MUTATE_SHOW_STANDALONE_STREET_NUMBER';
// actions
export const ADDRESS__RESUME_ADDRESS = 'ADDRESS__RESUME_ADDRESS';
export const ADDRESS__UPDATE_ADDRESS = 'ADDRESS__UPDATE_ADDRESS';
export const ADDRESS__GOOGLE_PREDICTION_SELECTED = 'ADDRESS__GOOGLE_PREDICTION_SELECTED';
export const ADDRESS__UPDATE_MANUAL_STREET_NUMBER = 'ADDRESS__UPDATE_MANUAL_STREET_NUMBER';
export const ADDRESS__UPDATE_SHOW_STANDALONE_STREET_NUMBER =
    'ADDRESS__UPDATE_SHOW_STANDALONE_STREET_NUMBER';

/* BillingInformation */
// mutations
export const BILLING_INFORMATION__MUTATE_PAYMENT_DETAILS_VALIDATION =
    'BILLING_INFORMATION__MUTATE_PAYMENT_DETAILS_VALIDATION';
// actions
export const BILLING_INFORMATION__UPDATE_PAYMENT_DETAILS_VALIDATION =
    'BILLING_INFORMATION__UPDATE_PAYMENT_DETAILS_VALIDATION';
export const BILLING_INFORMATION__UPDATE_LEAD_SOURCE = 'BILLING_INFORMATION__UPDATE_LEAD_SOURCE';

/* Cart */
// mutations
export const CART__MUTATE_CART = 'CART__MUTATE_CART';
export const CART__MUTATE_CART_ADD_QUOTE = 'CART__MUTATE_CART_ADD_QUOTE';
export const CART__MUTATE_CART_REMOVE_QUOTE = 'CART__MUTATE_CART_REMOVE_QUOTE';
export const CART__MUTATE_CART_ADD_INSTANT_QUOTE = 'CART__MUTATE_CART_ADD_INSTANT_QUOTE';
export const CART__MUTATE_CART_REMOVE_INSTANT_QUOTE = 'CART__MUTATE_CART_REMOVE_INSTANT_QUOTE';
export const CART__MUTATE_CART_ADD_SERVICE = 'CART__MUTATE_CART_ADD_SERVICE';
export const CART__MUTATE_CART_REMOVE_SERVICE = 'CART__MUTATE_CART_REMOVE_SERVICE';
export const CART__MUTATE_CART_LOADING_STATUS = 'CART__MUTATE_CART_LOADING_STATUS';
// actions
export const CART__UPDATE_CART = 'CART__UPDATE_CART';
export const CART__ADD_QUOTE_TO_CART = 'CART__ADD_QUOTE_TO_CART';
export const CART__REMOVE_QUOTE_FROM_CART = 'CART__REMOVE_QUOTE_FROM_CART';
export const CART__ADD_INSTANT_QUOTE_TO_CART = 'CART__ADD_INSTANT_QUOTE_TO_CART';
export const CART__REMOVE_INSTANT_QUOTE_FROM_CART = 'CART__REMOVE_INSTANT_QUOTE_FROM_CART';
export const CART__ADD_SERVICE_TO_CART = 'CART__ADD_SERVICE_TO_CART';
export const CART__REMOVE_SERVICE_FROM_CART = 'CART__REMOVE_SERVICE_FROM_CART';
// getters
export const CART__GET_PRICED_LAWNTREATMENT_IS_IN_CART =
    'CART__GET_PRICED_LAWNTREATMENT_IS_IN_CART';
export const CART__GET_NON_MOWING_SERVICES_IN_CART = 'CART__GET_NON_MOWING_SERVICES_IN_CART';
export const CART__GET_QUOTES_IN_CART = 'CART__GET_QUOTES_IN_CART';
export const CART__GET_QUOTES_AND_INSTANT_QUOTES_SERVICE_OBJECTS_IN_CART =
    'CART__GET_QUOTES_AND_INSTANT_QUOTES_SERVICE_OBJECTS_IN_CART';
export const CART__GET_MOWING_IN_CART = 'CART__GET_MOWING_IN_CART';

/* ContactInfo */
// mutations
export const CONTACT_INFO__MUTATE_EMAIL = 'CONTACT_INFO__MUTATE_EMAIL';
export const CONTACT_INFO__MUTATE_FIRST_NAME = 'CONTACT_INFO__MUTATE_FIRST_NAME';
export const CONTACT_INFO__MUTATE_LAST_NAME = 'CONTACT_INFO__MUTATE_LAST_NAME';
export const CONTACT_INFO__MUTATE_PHONE = 'CONTACT_INFO__MUTATE_PHONE';
export const CONTACT_INFO__MUTATE_VALID = 'CONTACT_INFO__MUTATE_VALID';
// actions
export const CONTACT_INFO__UPDATE_VALIDATION = 'CONTACT_INFO__UPDATE_VALIDATION';
export const CONTACT_INFO__UPDATE_EMAIL = 'CONTACT_INFO__UPDATE_EMAIL';
export const CONTACT_INFO__UPDATE_FIRST_NAME = 'CONTACT_INFO__UPDATE_FIRST_NAME';
export const CONTACT_INFO__UPDATE_LAST_NAME = 'CONTACT_INFO__UPDATE_LAST_NAME';
export const CONTACT_INFO__UPDATE_PHONE = 'CONTACT_INFO__UPDATE_PHONE';

/* CustomerLeads */
// mutations
export const CUSTOMER_LEADS__MUTATE_FORM = 'CUSTOMER_LEADS__MUTATE_FORM';
export const CUSTOMER_LEADS__MUTATE_LOADING_STATUS = 'CUSTOMER_LEADS__MUTATE_LOADING_STATUS';
// actions
export const CUSTOMER_LEADS__GET_DETAILS = 'CUSTOMER_LEADS__GET_DETAILS';
export const CUSTOMER_LEADS__ENSURE_LOADED = 'CUSTOMER_LEADS__ENSURE_LOADED';
export const CUSTOMER_LEADS__SAVE_FORM_DATA = 'CUSTOMER_LEADS__SAVE_FORM_DATA';
export const CUSTOMER_LEADS__SUBMIT = 'CUSTOMER_LEADS__SUBMIT';

/* Deal */
// mutations
export const DEAL__MUTATE_LOADING_STATUS = 'DEAL__MUTATE_LOADING_STATUS';
export const DEAL__MUTATE_VALID_DEAL = 'DEAL__MUTATE_VALID_DEAL';
export const DEAL__MUTATE_BANNER = 'DEAL__MUTATE_BANNER';
// actions
export const DEAL__ADD_DEAL = 'DEAL__ADD_DEAL';
export const DEAL__UPDATE_BANNER = 'DEAL__UPDATE_BANNER';

/* Error */
// mutations
export const ERROR__MUTATE_ERROR = 'ERROR__MUTATE_ERROR';
// actions
export const ERROR__SET_ERROR = 'ERROR__SET_ERROR';
export const ERROR__CLEAR_ERROR = 'ERROR__CLEAR_ERROR';

/* FeatureFlags */
// mutations
export const FEATURE_FLAGS__MUTATE_FLAGS = 'FEATURE_FLAGS__MUTATE_FLAGS';
// actions
export const FEATURE_FLAGS__REGISTER_EXPOSURE = 'FEATURE_FLAGS__REGISTER_EXPOSURE';
export const FEATURE_FLAGS__GET_FLAGS = 'FEATURE_FLAGS__GET_FLAGS';
// getters
export const FEATURE_FLAGS__ALL_FLAGS = 'FEATURE_FLAGS__ALL_FLAGS';

/* GetPricing */
// mutations
export const GET_PRICING__MUTATE_STATE = 'GET_PRICING__MUTATE_STATE';
// actions
export const GET_PRICING__UPDATE_STATE = 'GET_PRICING__UPDATE_STATE';

/* Loading */
// mutations
export const LOADING__MUTATE_QUOTING_ORDER = 'LOADING__MUTATE_QUOTING_ORDER';
export const LOADING__MUTATE_LOADING_TYPE = 'LOADING__MUTATE_LOADING_TYPE';
export const LOADING__MUTATE_QUOTED_ORDER_ROUTE = 'LOADING__MUTATE_QUOTED_ORDER_ROUTE';
export const LOADING__MUTATE_FINALIZING_ORDER = 'LOADING__MUTATE_FINALIZING_ORDER';
// actions
export const LOADING__QUOTING_ORDER = 'LOADING__QUOTING_ORDER';
export const LOADING__ORDER_QUOTED = 'LOADING__ORDER_QUOTED';
export const LOADING__ORDER_ERRORED = 'LOADING__ORDER_ERRORED';
export const LOADING__GO_TO_QUOTED_ORDER_ROUTE = 'LOADING__GO_TO_QUOTED_ORDER_ROUTE';
export const LOADING__FINALIZING_ORDER = 'LOADING__FINALIZING_ORDER';
export const LOADING__SET_LOADING_TYPE = 'LOADING__SET_LOADING_TYPE';

/* ManualRequest */
// mutations
export const MANUAL_REQUEST__MUTATE_VALIDATION = 'MANUAL_REQUEST__MUTATE_VALIDATION';
export const MANUAL_REQUEST__MUTATE_MANUAL_REQUEST =
    'manualRequest/MANUAL_REQUEST__MUTATE_MANUAL_REQUEST';
// actions
export const MANUAL_REQUEST__UPDATE_MANUAL_REQUEST = 'MANUAL_REQUEST__UPDATE_MANUAL_REQUEST';
export const MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST = 'MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST';

/* Modal */
// mutations
export const MODAL__MUTATE_MODAL = 'MODAL__MUTATE_MODAL';
export const MODAL__MUTATE_ALL_MODALS = 'MODAL__MUTATE_ALL_MODALS';
// actions
export const MODAL__CLOSE_MODAL = 'MODAL__CLOSE_MODAL';
export const MODAL__OPEN_MODAL = 'MODAL__OPEN_MODAL';
export const MODAL__CLOSE_ALL_MODALS = 'MODAL__CLOSE_ALL_MODALS';

/* Order */
// mutations
export const ORDER__MUTATE_NAME = 'ORDER__MUTATE_NAME';
export const ORDER__MUTATE_PHONE = 'ORDER__MUTATE_PHONE';
export const ORDER__MUTATE_ORDER = 'ORDER__MUTATE_ORDER';
export const ORDER__MUTATE_EMAIL = 'ORDER__MUTATE_EMAIL';
export const ORDER__MUTATE_PROPERTY_ID = 'ORDER__MUTATE_PROPERTY_ID';
export const ORDER__MUTATE_START_DATE = 'ORDER__MUTATE_START_DATE';
// actions
export const ORDER__UPDATE_NAME = 'ORDER__UPDATE_NAME';
export const ORDER__UPDATE_PHONE = 'ORDER__UPDATE_PHONE';
export const ORDER__UPDATE_EMAIL = 'ORDER__UPDATE_EMAIL';
export const ORDER__UPDATE_PROPERTY_ID = 'ORDER__UPDATE_PROPERTY_ID';
export const ORDER__UPDATE_ORDER = 'ORDER__UPDATE_ORDER';
export const ORDER__CREATE_QUOTE = 'ORDER__CREATE_QUOTE';
export const ORDER__UPDATE_START_DATE = 'ORDER__UPDATE_START_DATE';
export const ORDER__FINALIZE_WITH_PAYMENT = 'ORDER__FINALIZE_WITH_PAYMENT';
export const ORDER__GENERATE_UUID = 'ORDER__GENERATE_UUID';
// getters
export const ORDER__GET_PRICED_LAWNTREATMENT = 'ORDER__GET_PRICED_LAWNTREATMENT';
export const ORDER__GET_PRICED_MOWING_OPTIONS = 'ORDER__GET_PRICED_MOWING_OPTIONS';
export const ORDER__GET_HAS_ONE_TIME_MOWING_OPTION = 'ORDER__GET_HAS_ONE_TIME_MOWING_OPTION';
export const ORDER__GET_ONE_TIME_MOWING_OPTION = 'ORDER__GET_ONE_TIME_MOWING_OPTION';
export const ORDER__GET_CYCLE_PRICE_FOR_ONE_TIME_UNAVAILABLE =
    'ORDER__GET_CYCLE_PRICE_FOR_ONE_TIME_UNAVAILABLE';
export const ORDER__GET_DISABLED_DAYS = 'ORDER__GET_DISABLED_DAYS';
export const ORDER__GET_DISCOUNT_AMOUNT = 'ORDER__GET_DISCOUNT_AMOUNT';
export const ORDER__GET_CART_TOTALS = 'ORDER__GET_CART_TOTALS';
export const ORDER__GET_CART_TREATMENT_TOTAL = 'ORDER__GET_CART_TREATMENT_TOTAL';

/* OrderServiceLead */
// mutations
export const ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS =
    'ORDER_SERVICE_LEAD__MUTATE_LOADING_STATUS';
export const ORDER_SERVICE_LEAD__MUTATE_SERVICES_AND_BUDGET =
    'ORDER_SERVICE_LEAD__MUTATE_SERVICES_AND_BUDGET';
export const ORDER_SERVICE_LEAD__MUTATE_SERVICE = 'ORDER_SERVICE_LEAD__MUTATE_SERVICE';
export const ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS =
    'ORDER_SERVICE_LEAD__MUTATE_ADDITIONAL_DETAILS';
export const ORDER_SERVICE_LEAD__MUTATE_OUT_OF_MARKET_SERVICES =
    'ORDER_SERVICE_LEAD__MUTATE_OUT_OF_MARKET_SERVICES';
// actions
export const ORDER_SERVICE_LEAD__UPDATE_SERVICE = 'ORDER_SERVICE_LEAD__UPDATE_SERVICE';
export const ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET = 'ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET';
export const ORDER_SERVICE_LEAD__GET_DETAILS = 'ORDER_SERVICE_LEAD__GET_DETAILS';
export const ORDER_SERVICE_LEAD__SUBMIT = 'ORDER_SERVICE_LEAD__SUBMIT';
export const ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA = 'ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA';

/* OtherServices */
// actions
export const OTHER_SERVICES__TOGGLE_SELECTABLE_QUOTE = 'OTHER_SERVICES__TOGGLE_SELECTABLE_QUOTE';
export const OTHER_SERVICES__TOGGLE_SELECTABLE_INSTANT_QUOTE =
    'OTHER_SERVICES__TOGGLE_SELECTABLE_INSTANT_QUOTE';
// getters
export const OTHER_SERVICES__GET_QUOTES_IN_CART_BY_SERVICE_ID =
    'OTHER_SERVICES__GET_QUOTES_IN_CART_BY_SERVICE_ID';

/* ScreenSize */
// mutations
export const SCREEN_SIZE__MUTATE_SCREEN = 'SCREEN_SIZE__MUTATE_SCREEN';
// actions
export const SCREEN_SIZE__UPDATE_SCREEN = 'SCREEN_SIZE__UPDATE_SCREEN';
// getters
export const SCREEN_SIZE__GET_DESKTOP_SCREEN = 'SCREEN_SIZE__GET_DESKTOP_SCREEN';
export const SCREEN_SIZE__GET_TABLET_SCREEN = 'SCREEN_SIZE__GET_TABLET_SCREEN';
export const SCREEN_SIZE__GET_MOBILE_SCREEN = 'SCREEN_SIZE__GET_MOBILE_SCREEN';

export const TURNSTILE__MUTATE_TOKEN = 'TURNSTILE__MUTATE_TOKEN';
export const TURNSTILE__SAVE_TOKEN = 'TURNSTILE__SAVE_TOKEN';
export const TURNSTILE__DISPLAY_LOADING_SPINNER = 'TURNSTILE__DISPLAY_LOADING_SPINNER';

/* Intent - serviceType */
// mutations
export const ORDER__MUTATE_INTENT = 'ORDER__MUTATE_INTENT';
// actions
export const ORDER__UPDATE_INTENT = 'ORDER__UPDATE_INTENT';
// getters
export const ORDER__GET_INTENT = 'ORDER__GET_INTENT';
